var chunkMapping = {
	"3984": [
		87705
	],
	"4048": [
		67214
	],
	"5480": [
		5480
	],
	"5798": [
		55798
	],
	"6119": [
		6707,
		38226
	],
	"6535": [
		52450,
		50188
	],
	"8567": [
		2579
	],
	"9582": [
		69552
	]
};
var idToExternalAndNameMapping = {
	"2579": [
		"default",
		"./ProgramCard",
		96467
	],
	"5480": [
		"default",
		"./Banner",
		34473
	],
	"6707": [
		"default",
		"./CommunicationSettings",
		27122
	],
	"38226": [
		"default",
		"./MemberNav",
		35988
	],
	"50188": [
		"default",
		"./ChatUtils",
		50074
	],
	"52450": [
		"default",
		"./Chat",
		50074
	],
	"55798": [
		"default",
		"./Modal",
		34473
	],
	"67214": [
		"default",
		"./FeedbackWidget",
		61152
	],
	"69552": [
		"default",
		"./EligibilityWidget",
		1990
	],
	"87705": [
		"default",
		"./ProgramCardProvider",
		96467
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}